import Keycloak from 'keycloak-js';

// Pobieramy konfigurację z globalnego obiektu okna (zdefiniowanego w entrypoint.sh) 
// lub ze zmiennych środowiskowych (dla trybu deweloperskiego)
const getEnv = (key) => {
    return (window._env_ && window._env_[key]) || process.env[key];
};

const keycloakConfig = {
    url: getEnv('REACT_APP_KEYCLOAK_URL'),
    realm: getEnv('REACT_APP_KEYCLOAK_REALM'),
    clientId: getEnv('REACT_APP_KEYCLOAK_CLIENTID'),
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
